import { Navigate } from "react-router-dom";
import {
  getCompanyCode,
  hasSession,
  isAssignedCompany,
  needsPasswordChange,
} from "./auth/authSession";

const CompanyAssignedRoute = ({ children }) => {
  if (!hasSession()) {
    return <Navigate to="/login" replace />;
  }
  if (needsPasswordChange()) {
    return <Navigate to="/change-password" replace />;
  }
  const company = getCompanyCode();
  if (!company || !isAssignedCompany(company)) {
    return <Navigate to="/company" replace />;
  }
  return children;
};

export default CompanyAssignedRoute;
